module.exports = __webpack_public_path__ + "static/media/onboard-content3.5aaa7536.png";